<div ><label class="info-label">{{title}}</label></div>
<fieldset [attr.aria-label]="title">
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      [checked]="availabilityIsSelected(instockKeyword)"
      (change)="onChromebookPlusChange(instockKeyword)"
      (keyup.enter)="onChromebookPlusChange(instockKeyword)">
      <span class="filter-label">{{touchscreenLabel}}</span>
    </mat-checkbox>
    <div class="spacer-medium">
    </div>
  </div>
</fieldset>
